import { Component, ChangeDetectionStrategy, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tooltip } from 'primeng/tooltip';

export interface RowStatusRendererConfig {
  changedRows: Signal<Set<object>>;
  errorsByRow: Signal<Map<object, string[]>>;
}

@Component({
  selector: 'app-row-status-renderer',
  standalone: true,
  imports: [CommonModule, Tooltip],
  template: `
    @if (errors.length) {
      <span class="status-error" [pTooltip]="formattedErrors" [escape]="false" tooltipPosition="right">!</span>
    } @else if (isChanged) {
      <span class="status-dot" pTooltip="Modified" tooltipPosition="right"></span>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
      }

      .status-dot {
        display: inline-block;
        width: 0.75rem;
        height: 0.75rem;
        border-radius: 50%;
        background-color: #ff80ff;
      }

      .status-error {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background-color: #d0021b;
        color: #fff;
        font-size: 0.6875rem;
        font-weight: 700;
        line-height: 1;
        cursor: default;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowStatusRendererComponent {
  @Input() rowData: object | undefined;
  @Input() config: RowStatusRendererConfig | undefined;

  get errors(): string[] {
    return this.config?.errorsByRow().get(this.rowData ?? {}) ?? [];
  }

  get isChanged(): boolean {
    return this.config?.changedRows().has(this.rowData ?? {}) ?? false;
  }

  get formattedErrors(): string {
    return this.errors.map((error) => this.escapeHtml(error)).join('<br>');
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

}
